import "./participantChange.css";
import * as ConversationEntryUtil from "../helpers/conversationEntryUtil";
import { util } from "../helpers/common";
import { t } from "../awac/i18n";

export default function ParticipantChange({conversationEntry}) {
    /**
     * Generates a text with the participant change operation infomation.
     * Internal bot/deployment names map to the friendly agent name (Lia)
     * via the shared conversationEntryUtil.friendlyActorName helper.
     * @returns {string}
     */
    function generateParticipantChangeText() {
        const participantName = ConversationEntryUtil.friendlyActorName(
            ConversationEntryUtil.getParticipantChangeEventPartcipantName(conversationEntry), null);
        const hasParticipantJoined = ConversationEntryUtil.hasParticipantJoined(conversationEntry);
        const formattedTime = util.getFormattedTime(conversationEntry.transcriptedTimestamp);
        const participantChangeText = t(hasParticipantJoined ? "chat.joined" : "chat.left", { name: participantName, time: formattedTime });

        return participantChangeText;
    }

    return (
        <p className="participantChangeText">{generateParticipantChangeText()}</p>
    );
}